module.exports = __webpack_public_path__ + "img/main-3.dc014a72.svg";